<template>
  <slot :error="validation.msg" :state="validation.state" :count-hint="countHint" name="default" />
</template>
<script setup lang="ts">
import type { BaseValidation } from '@vuelidate/core'
import { computed } from 'vue'

import { getValidationState } from '@/helpers/validationHelper.ts'

const props = defineProps<{
  validation: BaseValidation
}>()

const validation = computed(() => getValidationState(props.validation))

const countHint = computed(() => {
  const maxLength = props.validation.maxLength?.$params.max
  if (maxLength && typeof props.validation.$model === 'string') {
    return `${String(props.validation.$model).length}/${maxLength}`
  }
  return undefined
})
</script>
